import React from "react"
import {MainCP}  from "../../Components/Login/MainCP"

const ViewLogin: React.FC = () => <MainCP/>

export default ViewLogin;